//This file is used for maintain JavaScript functions that are bound to a particular scope or view
(function(module) {
  'use strict';
  module
    .controller('reportController', ['$scope', 'report', '$stateParams', 'progressBar', 'ngDialog',
      'uiGridConstants', 'commonDialogMessage', '$filter', '$q', 'clientSelectService', 'agencySelectService',
      'toastr', 'profileFieldService',
      'currency', 'toastFactory', 'authService',
      function($scope, report, $stateParams, progressBar, ngDialog, uiGridConstants,
        commonDialogMessage, $filter, $q, clientSelectService, agencySelectService, toastr, profileFieldService,
        currency, toastFactory,
        authService) {
        const progress = progressBar.getProgressBar();
        $scope.dateCustFrom = new Date();
        $scope.dateCustTo = addMonth($scope.dateCustFrom); // Look ahead 1 month by default
        $scope.isCustomDate = false;
        $scope.isMonthDate = 'monthYear';
        let profileFields = {};
        let profiles = {};
        let fromdate = null;
        let todate = null;
        let selectedClientId = clientSelectService.getSelectedClient().id;
        let gridData = [];

        function lastDateOfMonth(month, year) {
          return new Date(year, month, 0).toLocaleDateString().replace(/[^ -~]/g, '');
        };

        function firstDateOfMonth(month, year) {
          return new Date(year, month - 1, 1).toLocaleDateString().replace(/[^ -~]/g, '');
        };
        $scope.years = _.range(2010, 2099);

        function validateToDate(fromDate, toDate) {
          return (fromDate <= toDate);
        };

        function addMonth(startDate) {
          // Does not handle end-of-month edge case, e.g. Oct 31 + 1 month = Dec 01
          return new Date(new Date(startDate).setMonth(startDate.getMonth() + 1));
        }
        $scope.monthList = [{
          id: 1,
          name: 'January',
        }, {
          id: 2,
          name: 'February',
        }, {
          id: 3,
          name: 'March',
        }, {
          id: 4,
          name: 'April',
        }, {
          id: 5,
          name: 'May',
        }, {
          id: 6,
          name: 'June',
        }, {
          id: 7,
          name: 'July',
        }, {
          id: 8,
          name: 'August',
        }, {
          id: 9,
          name: 'September',
        }, {
          id: 10,
          name: 'October',
        }, {
          id: 11,
          name: 'November',
        }, {
          id: 12,
          name: 'December',
        }, ];
        $scope.monthDateSelected = function() {
          $scope.isCustomDate = false;
        };
        $scope.reportList = [{
          id: 1,
          name: 'Air activity',
        }, {
          id: 2,
          name: 'Hotel activity',
        }, {
          id: 3,
          name: 'Car activity',
        }, {
          id: 4,
          name: 'All transaction',
        }, {
          id: 5,
          name: 'Active booking user',
        }, {
          id: 6,
          name: 'Active system user',
        }, ];
        $scope.reportId = 2;
        $scope.columnTypeList = [{
          value: 'all',
          name: 'All',
        }, {
          value: 'visible',
          name: 'Visible',
        }, ];
        $scope.columnTypeId = 'all';
        $scope.yearName = new Date().getFullYear();
        $scope.monthId = new Date().getMonth() + 1;
        // DRY: function for creating warning toasts
        function toast_warn(errMsg) {
          toastr.warning(errMsg, 'Alert', {
            closeButton: true,
            timeOut: 3500,
          });
        };

        function toast_info(infoMsg) {
          toastr.info(infoMsg, 'Info', {
            closeButton: true,
            timeOut: 3500,
          });
        };

        function validateAgencyAndClientSelection() {
          const agency = agencySelectService.getSelectedAgency();
          const client = clientSelectService.getSelectedClient();
          return {
            agencyValid: agency.id != null && Number.isInteger(agency.id),
            clientValid: client.id != null && Number.isInteger(client.id),
          };
        }
        $scope.searchReport = function() {
          if (authService.getLoginMember().Role === 3) {
            selectedClientId = authService.getLoginMember().OrganizationId;
            showReport(selectedClientId);
          } else {
            const valid = validateAgencyAndClientSelection();
            if (valid.agencyValid && valid.clientValid) {
              selectedClientId = clientSelectService.getSelectedClient().id;
              showReport(selectedClientId);
            } else if (valid.agencyValid) {
              //toastFactory.toast_info('Please select a client.');
            } else {
              //toastFactory.toast_info('Please select an agency and then client.');
            }
          };
          $scope.gridTranOptions = setTranGridOption();
          $scope.gridDetails = _.cloneDeep($scope.gridTranOptions);
        };

        function showReport(selectedClientId) {
          if ($scope.isCustomDate) {
            fromdate = $filter('date')(($scope.dateCustFrom), 'yyyy-MM-dd').replace(/[^ -~]/g, '');
            todate = $filter('date')(($scope.dateCustTo), 'yyyy-MM-dd').replace(/[^ -~]/g, '');
          } else {
            fromdate = $filter('date')(new Date(firstDateOfMonth($scope.monthId, $scope.yearName)), 'yyyy-MM-dd');
            todate = $filter('date')(new Date(lastDateOfMonth($scope.monthId, $scope.yearName)), 'yyyy-MM-dd');
          };
          if (validateToDate(fromdate, todate)) {
            switch ($scope.reportId) {
              case 1:
                getAirReport(fromdate, todate, selectedClientId);
                break;
              case 2:
                getHotelReport(fromdate, todate, selectedClientId);
                break;
              case 3:
                getCarReport(fromdate, todate, selectedClientId);
                break;
              case 4:
                getTransactionsReport(fromdate, todate, selectedClientId);
                break;
              case 5:
                getBookingActiveUserReport(fromdate, todate, selectedClientId);
                break;
              case 6:
                getActiveUserReport();
                break;
              default:
                getHotelReport(fromdate, todate, selectedClientId);
                break;
            };
          } else {
            toast_warn(commonDialogMessage.dateErrorMessage);
          };
        };

        function transactionGrid() {
          $scope.gridDetails = _.cloneDeep($scope.gridTranOptions);
          $scope.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
        };

        function smsLogGrid() {
          $scope.gridDetails = _.cloneDeep($scope.gridTranOptions);
          $scope.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
        };
        // ui-grid code.
        const paginationOptions = {
          pageNumber: 1,
          pageSize: 25,
          sort: null,
        };

        function setTranGridOption() {
          let data = {
            paginationPageSizes: [5, 10, 25, 50],
            enableFiltering: true,
            enableGridMenu: true,
            paginationPageSize: 25,
            useExternalPagination: false,
            useExternalSorting: false,
            enableColumnResizing: true,
            exporterMenuPdf: false,
            exporterMenuCsv: false,
            exporterCsvFilename: 'Report.csv',
            columnDefs: [{
              name: 'Traveler',
              visible: true,
              displayName: 'Traveler Name',
              enableHiding: true,
              enableSorting: true,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableFiltering: true,
              enableColumnResizing: true,
              maxWidth: 250,
            }, {
              name: 'TravelerEmail',
              visible: false,
              displayName: 'Traveler Email',
              enableHiding: false,
              enableSorting: true,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableFiltering: true,
              enableColumnResizing: true,
              maxWidth: 250,
            },{
              name: 'Source',
              visible: true,
              displayName: 'Source',
              enableHiding: true,
              enableSorting: true,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableFiltering: true,
              enableColumnResizing: true,
              maxWidth: 250,
            }, {
              name: 'Confirmation',
              visible: true,
              displayName: 'Confirmation',
              enableHiding: true,
              enableSorting: true,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableFiltering: true,
              enableColumnResizing: true,
              maxWidth: 250,
            }, {
              name: 'Supplier',
              visible: true,
              displayName: 'Supplier',
              enableHiding: true,
              enableSorting: true,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableFiltering: true,
              enableColumnResizing: true,
              maxWidth: 250,
            }, {
              name: 'StartDate',
              visible: true,
              enableHiding: true,
              displayName: 'Start Date',
              enableSorting: true,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableFiltering: true,
              enableColumnResizing: true,
              maxWidth: 250,
              sort: {
                direction: uiGridConstants.DESC,
                priority: 0,
              },
              cellFilter: 'date:\'MM-dd-yyyy\'',
            }, {
              name: 'EndDate',
              visible: true,
              displayName: 'End Date',
              enableHiding: true,
              enableSorting: true,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableFiltering: true,
              enableColumnResizing: true,
              maxWidth: 250,
              cellFilter: 'date:\'MM-dd-yyyy\'',
            }, {
              name: 'AddedOn',
              visible: true,
              displayName: 'Added On',
              enableHiding: true,
              enableSorting: true,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableFiltering: true,
              enableColumnResizing: true,
              maxWidth: 250,
              cellFilter: 'date:\'MM-dd-yyyy HH:mm:ss\'',
            }, {
              name: 'StartLocation',
              visible: true,
              displayName: 'Start Location',
              enableHiding: true,
              enableSorting: true,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableFiltering: true,
              enableColumnResizing: true,
              maxWidth: 250,
            }, {
              name: 'EndLocation',
              visible: true,
              displayName: 'End Location',
              enableHiding: true,
              enableSorting: true,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableFiltering: true,
              enableColumnResizing: true,
              maxWidth: 250,
            }, {
              name: 'Cancelled',
              visible: false,
              displayName: 'Cancelled',
              enableHiding: true,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableSorting: true,
              enableFiltering: true,
              enableColumnResizing: true,
              maxWidth: 250,
            }, {
              name: 'Total',
              visible: true,
              displayName: 'Total',
              enableHiding: true,
              enableSorting: true,
              enableFiltering: true,
              enableColumnResizing: true,
              maxWidth: 250,
            }, {
              name: 'Agent',
              visible: false,
              displayName: 'Agent',
              enableHiding: true,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableSorting: true,
              enableFiltering: true,
              exporterSuppressExport: true,
              enableColumnResizing: true,
              maxWidth: 250,
            }, {
              name: 'Type',
              visible: false,
              displayName: 'Type',
              enableHiding: false,
              enableSorting: true,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableFiltering: true,
              exporterSuppressExport: true,
              enableColumnResizing: true,
              maxWidth: 250,
            }, {
              name: 'NumberOfRooms',
              visible: false,
              displayName: 'Number Of Rooms',
              enableHiding: true,
              enableSorting: true,
              exporterSuppressExport: ($scope.reportId === 1 || $scope.reportId === 3 ) ? true : false,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableFiltering: true,
              enableColumnResizing: true,
              maxWidth: 250,
            }, {
              name: 'NumberOfNights',
              visible: false,
              displayName: 'Number Of Nights',
              enableHiding: true,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableSorting: true,
              exporterSuppressExport: ($scope.reportId === 1 || $scope.reportId === 3 ) ? true : false,
              enableFiltering: true,
              enableColumnResizing: true,
              maxWidth: 250,
            }, {
              name: 'Phone',
              visible: false,
              displayName: 'Phone',
              enableHiding: true,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableSorting: true,
              exporterSuppressExport: $scope.reportId === 1 ? true : false,
              enableFiltering: true,
              enableColumnResizing: true,
              maxWidth: 250,
            }, {
              name: 'CityName',
              visible: false,
              displayName: 'City Name',
              enableHiding: true,
              enableSorting: true,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableFiltering: true,
              exporterSuppressExport: $scope.reportId === 1 ? true : false,
              enableColumnResizing: true,
              maxWidth: 250,
            }, {
              name: 'StateProv',
              visible: false,
              displayName: 'State',
              enableHiding: true,
              enableSorting: true,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableFiltering: true,
              exporterSuppressExport: $scope.reportId === 1 ? true : false,
              enableColumnResizing: true,
              maxWidth: 250,
            }, {
              name: 'Country',
              visible: false,
              displayName: 'Country',
              enableHiding: true,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableSorting: true,
              exporterSuppressExport: $scope.reportId === 1 ? true : false,
              enableFiltering: true,
              enableColumnResizing: true,
              maxWidth: 250,
            }, {
              name: 'BookingType',
              visible: false,
              displayName: 'Booking Type',
              enableHiding: true,
              enableSorting: true,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableFiltering: true,
              exporterSuppressExport: true,
              enableColumnResizing: true,
              maxWidth: 250,
            }, ],
            onRegisterApi: function(gridApi) {
              $scope.gridApi = gridApi;
              $scope.gridApi.core.on.sortChanged($scope, function(grid, sortColumns) {
                if (!sortColumns.length) {
                  paginationOptions.sort = null;
                } else {
                  paginationOptions.sort = sortColumns[0].sort.direction;
                }
                updateGridPagination($scope.gridDetails.data);
                showReport(selectedClientId);
              });
              gridApi.pagination.on.paginationChanged($scope, function(newPage, pageSize) {
                paginationOptions.pageNumber = newPage;
                paginationOptions.pageSize = pageSize;
                updateGridPagination($scope.gridDetails.data);
                showReport(selectedClientId);
              });
            },
          };          
          for (const [key, value] of Object.entries(profileFields)) {
            const i = 0;
            const profileField = {
              name: 'ProfileFieldData[ ' + key + ' ][0].ProfileFieldValue',
              visible: false,
              displayName: value.Name,
              enableHiding: true,
              enableSorting: true,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableFiltering: true,
              enableColumnResizing: true,
              maxWidth: 250
            };
            data.columnDefs.push(profileField);
          };
          return data;
        };

        function setTravelerProfileFields(profileFields, optionList) {
          const travelerProfileFields = profileFields.map(function (profileField) {
            let isProfileFieldExit = false;
            if (!!optionList.length) {
              return optionList.filter(function (option) {
                if (option !== null && option.ProfileFieldId === profileField.Id) {
                  isProfileFieldExit = true;
                  return option;
                }
              }).map(function (option) {
                const value = ((option.ProfileFieldValue !== null) ? option.ProfileFieldValue : '-');
                return {
                  ProfileFieldName: profileField.Name,
                  ProfileFieldValue: value
                };

              });
              if (isProfileFieldExit === false) {
                return {
                  ProfileFieldName: profileField.Name,
                  ProfileFieldValue: "-"
                };
              }
            } else {
              return {
                ProfileFieldName: profileField.Name,
                ProfileFieldValue: "-"
              };
            }
          });
          return travelerProfileFields;
        };

        $scope.gridTranOptions = [];

        function getHotelReport(fromdate, todate, organizationId) {
          progress.start();
          report.getHotelActivity(fromdate, todate, organizationId).then(function(response) {
              let tripHotelsContext = getHotels(response.data);
              $scope.isExportData = !!tripHotelsContext.length ? true : false;
              $scope.gridTranOptions = setTranGridOption();
              $scope.gridTranOptions.data = tripHotelsContext;
              $scope.gridTranOptions.totalItems = tripHotelsContext.length;
              updateGridPagination(tripHotelsContext);
              transactionGrid();
            }, function(err) {
              if (err.status != 401) {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = `<p>${err.statusText}</p>`;
                    $scope.errTitle = 'Report Error';
                  },],
                });
              }
            })
            .finally(function() {
              progress.complete();
            });
        };

        function updateGridPagination(gridData) {
          $scope.gridDetails.data = gridData;
          $scope.gridDetails.totalItems = gridData.length;
          $scope.gridApi.grid.options.totalItems = $scope.gridTranOptions.totalItems;
        }
        $scope.getProfiles = function() {
          if (authService.getLoginMember().Role === 3) {
            selectedClientId = authService.getLoginMember().OrganizationId;
          } else {
            const valid = validateAgencyAndClientSelection();
            if (valid.agencyValid && valid.clientValid) {
              selectedClientId = clientSelectService.getSelectedClient().id;
            } else if (valid.agencyValid) {
              //toastFactory.toast_info('Please select a client.');
            } else {
              //toastFactory.toast_info('Please select an agency and then client.');
            }
          };
          report.getProfiles(selectedClientId).then(function(response) {
            profiles = response.data;
          });
        }
        $scope.getProfileFields = function() {
          if (authService.getLoginMember().Role === 3) {
            selectedClientId = authService.getLoginMember().OrganizationId;
          } else {
            const valid = validateAgencyAndClientSelection();
            if (valid.agencyValid && valid.clientValid) {
              selectedClientId = clientSelectService.getSelectedClient().id;
            } else if (valid.agencyValid) {
              //toastFactory.toast_info('Please select a client.');
            } else {
              //toastFactory.toast_info('Please select an agency and then client.');
            }
          };
          profileFieldService.getProfileFieldsByOrgId(selectedClientId).then(function(response) {
            profileFields = response.data;
          });
        };

        function getHotels(hotels) {
          return hotels.map(function(hotel) {
            let ProfileFieldData = {};
            for (let profile of profiles) {
              if (hotel.Member.Email === profile.Email) {
                ProfileFieldData = setTravelerProfileFields(profileFields, profile.ProfileFieldIdAndValues);
              }
            }
            let travelerName, name;
            if (hotel.GuestNames !== null) {
              name = hotel.GuestNames;
              name = name.split(" ");
              travelerName = name[1] + ', ' + name[0];
            } else if (!!hotel.Member) {
              travelerName = hotel.Member.LastName + ', ' + hotel.Member.FirstName;
            } else {
              travelerName = '';
            }
            return {
              Id: hotel.Id,
              //Traveler: ((!!hotel.Member) ? hotel.Member.LastName + '/' + hotel.Member.FirstName : ''),
              Traveler: travelerName,
              TravelerEmail: ((!!hotel.Member) ? hotel.Member.Email : ''),
              CityName: hotel.CityName + '' + hotel.PostalCode,
              StateProv: hotel.StateProv,
              Country: hotel.Country,
              Phone: hotel.PhoneNumber,
              Confirmation: hotel.Confirmation,
              Cancelled: ((hotel.Cancelled) ? 'Yes' : 'No'),
              Type: hotel.RoomType,
              NumberOfRooms: hotel.NumberOfRooms,
              NumberOfNights: hotel.NumberOfNights,
              StartDate: hotel.CheckInDate,
              EndDate: hotel.CheckOutDate,
              AddedOn: hotel.AddedDateTime,
              Email: hotel.Member.Email,
              Company: ((!!hotel.Member) ? hotel.Member.Organization.Name : ''),
              Supplier: hotel.HotelName,
              Source: ((!!hotel.BookingSource) ? hotel.BookingSource : ''),
              ProfileFieldData: ProfileFieldData,
              StartLocation: hotel.CityName,
              EndLocation: hotel.CityName,
              Agent: ((!!hotel.Member) ? hotel.Member.DisplayName : ''),
              Total: currency.getCurrencySymbol(hotel.CurrencyCode) + hotel.Total,
              BookingType: ((!!hotel.TripId) ? 'Trip' : 'Booking'),
              AgentNotes: ((!!hotel.AgentNotes.length) ? getLatestAgentNote(hotel.AgentNotes) : ''),
            };
          });
        };

        function getAirReport(fromdate, todate, organizationId) {
          progress.start();
          report.getAirActivity(fromdate, todate, organizationId).then(function(response) {
              let tripFlightsContext = getFlights(response.data);
              $scope.isExportData = !!tripFlightsContext.length ? true : false;
              $scope.gridTranOptions = setTranGridOption();
              $scope.gridTranOptions.data = tripFlightsContext;
              $scope.gridTranOptions.totalItems = tripFlightsContext.length;
              updateGridPagination(tripFlightsContext);
              transactionGrid();
            }, function(err) {
              if (err.status != 401) {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = `<p>${err.statusText}</p>`;
                    $scope.errTitle = 'Report Error';
                  },],
                });
              }
            })
            .finally(function() {
              progress.complete();
            });
        };

        function getFlights(flights) {
          return flights.map(function(flight) {
            let ProfileFieldData = {};
            for (let profile of profiles) {
              if (flight.Member.Email === profile.Email) {
                ProfileFieldData = setTravelerProfileFields(profileFields, profile.ProfileFieldIdAndValues);
              }
            }
            let travelerName;
            if (flight.AirReservation.AirTravelers.length !== 0 && flight.AirReservation.AirTravelers[0].LastName !== null && flight.AirReservation.AirTravelers[0]
              .GivenName !== null) {
              travelerName = flight.AirReservation.AirTravelers[0].LastName + ', ' + flight.AirReservation.AirTravelers[
                0].GivenName;
            } else if (!!flight.Member) {
              travelerName = flight.Member.LastName + ', ' + flight.Member.FirstName;
            } else {
              travelerName = '';
            }
            return {
              Id: flight.Id,
              Traveler: travelerName,
              TravelerEmail: ((!!flight.Member) ? flight.Member.Email : ''),
              CityName: '',
              StateProv: '',
              Country: '',
              Phone: '',
              Confirmation: flight.ConfirmationNumber,
              Cancelled: ((flight.Cancelled) ? 'Yes' : 'No'),
              Type: '',
              NumberOfRooms: '',
              NumberOfNights: '',
              StartDate: flight.DepartureDateTime,
              EndDate: flight.ArrivalDateTime,
              AddedOn: flight.AddedDateTime,
              Company: ((!!flight.Member) ? flight.Member.Organization.Name : ''),
              Supplier: flight.OperatingAirline,
              Source: ((!!flight.BookingSource) ? flight.BookingSource : ''),
              ProfileFieldData: ProfileFieldData,
              StartLocation: flight.DepartureName,
              EndLocation: flight.ArrivalName,
              Agent: ((!!flight.Member) ? flight.Member.DisplayName : ''),
              Total: currency.getCurrencySymbol(flight.AirReservation.CurrencyCode) + flight.AirReservation
                .TotalFare,
              BookingType: ((!!flight.TripId) ? 'Trip' : 'Booking'),
              AgentNotes: ((!!flight.AgentNotes.length) ? getLatestAgentNote(flight.AgentNotes) : ''),
            };
          });
        };

        function getCarReport(fromdate, todate, organizationId) {
          progress.start();
          report.getCarActivity(fromdate, todate, organizationId).then(function(response) {
              let tripCarsContext = getCars(response.data);
              $scope.isExportData = !!tripCarsContext.length ? true : false;
              $scope.gridTranOptions = setTranGridOption();
              $scope.gridTranOptions.data = tripCarsContext;
              $scope.gridTranOptions.totalItems = tripCarsContext.length;
              updateGridPagination(tripCarsContext);
              transactionGrid();
            }, function(err) {
              if (err.status != 401) {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = `<p>${err.statusText}</p>`;
                    $scope.errTitle = 'Report Error';
                  },],
                });
              }
            })
            .finally(function() {
              progress.complete();
            });
        };

        function getCars(cars) {
          return cars.map(function(car) {
            let ProfileFieldData = {};
            for (let profile of profiles) {
              if (car.Member.Email === profile.Email) {
                ProfileFieldData = setTravelerProfileFields(profileFields, profile.ProfileFieldIdAndValues);
              }
            }
            let travelerName, name;
            if (car.Travelers !== null) {
              name = car.Travelers;
              name = name.split(" ");
              travelerName = name[1] + ', ' + name[0];
            } else if (!!car.Member) {
              travelerName = car.Member.LastName + ', ' + car.Member.FirstName;
            } else {
              travelerName = '';
            }
            return {
              Id: car.Id,
              Traveler: travelerName,
              TravelerEmail: ((!!car.Member) ? car.Member.Email : ''),
              CityName: '',
              StateProv: '',
              Country: '',
              Phone: '',
              Confirmation: car.Confirmation,
              Cancelled: ((car.Cancelled) ? 'Yes' : 'No'),
              Type: car.CarModel,
              NumberOfRooms: '',
              NumberOfNights: '',
              StartDate: car.PickUpDateTime,
              EndDate: car.DropOffDateTime,
              AddedOn: car.AddedDateTime,
              Company: ((!!car.Member) ? car.Member.Organization.Name : ''),
              Supplier: car.RentalCompany,
              Source: ((!!car.BookingSource) ? car.BookingSource : ''),
              ProfileFieldData: ProfileFieldData,
              StartLocation: car.PickUpLocation,
              EndLocation: car.DropOffLocation,
              Agent: ((!!car.Member) ? car.Member.DisplayName : ''),
              Total: currency.getCurrencySymbol(car.CurrencyCode) + car.TotalCharge,
              BookingType: ((!!car.TripId) ? 'Trip' : 'Booking'),
              AgentNotes: ((!!car.AgentNotes.length) ? getLatestAgentNote(car.AgentNotes) : ''),
            };
          });
        };

        function getLatestAgentNote(agentNotes) {
          let sortByDateDesc = function(a, b) {
            return a.LastUpdated < b.LastUpdated ? 1 : a.LastUpdated > b.LastUpdated ? -1 : 0;
          };
          agentNotes.sort(sortByDateDesc);
          return agentNotes[0].Note;
        };

        function getTransactionsReport(fromdate, todate, organizationId) {
          progress.start();
          const promiseFlight = report.getAirActivity(fromdate, todate, organizationId);
          const promiseCar = report.getCarActivity(fromdate, todate, organizationId);
          const promiseHotel = report.getHotelActivity(fromdate, todate, organizationId);
          $q.all([promiseFlight, promiseCar, promiseHotel]).then(
              function(response) {
                let transactionList = [];
                let flightsContext = response[0].data;
                let carsContext = response[1].data;
                let hotelsContext = response[2].data;
                let flightList = getFlights(flightsContext);
                let carList = getCars(carsContext);
                let hotelList = getHotels(hotelsContext);
                transactionList.push.apply(transactionList, flightList);
                transactionList.push.apply(transactionList, carList);
                transactionList.push.apply(transactionList, hotelList);
                $scope.isExportData = !!transactionList.length ? true : false;
                $scope.gridTranOptions = setTranGridOption();
                $scope.gridTranOptions.data = transactionList;
                $scope.gridTranOptions.totalItems = transactionList.length;
                updateGridPagination(transactionList);
                transactionGrid();
              },
              function(err) {
                if (err.status != 401) {
                  ngDialog.open({
                    template: 'templates/partials/viewErrorMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function ($scope) {
                      $scope.errMsg = `<p>${err.statusText}</p>`;
                      $scope.errTitle = 'Report Error';
                    },],
                  });
                }
              })
            .finally(function() {
              progress.complete();
            });
        };

        function userGridOption() {
          return {
            paginationPageSizes: [5, 10, 25, 50],
            enableFiltering: true,
            enableGridMenu: true,
            paginationPageSize: 25,
            useExternalPagination: false,
            useExternalSorting: false,
            enableColumnResizing: true,
            exporterMenuPdf: false,
            exporterMenuCsv: false,
            exporterCsvFilename: 'Report.csv',
            columnDefs: [{
              name: 'FirstName',
              visible: true,
              displayName: 'First Name',
              enableHiding: true,
              enableSorting: true,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableFiltering: true,
              enableColumnResizing: true,
              maxWidth: 250,
              sort: {
                direction: uiGridConstants.ASC,
                priority: 0,
              },
            }, {
              name: 'LastName',
              visible: true,
              displayName: 'Last Name',
              enableHiding: true,
              enableSorting: true,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableFiltering: true,
              enableColumnResizing: true,
              maxWidth: 250,
            }, {
              name: 'Email',
              visible: true,
              displayName: 'Email',
              enableHiding: true,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableSorting: true,
              enableFiltering: true,
              enableColumnResizing: true,
              maxWidth: 250,
            }, {
              name: 'Phone',
              visible: true,
              displayName: 'Phone',
              enableHiding: true,
              enableSorting: true,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableFiltering: true,
              enableColumnResizing: true,
              maxWidth: 250,
            }, {
              name: 'TripLinkEmail',
              visible: true,
              enableHiding: true,
              displayName: 'TripLink Email',
              enableSorting: true,
              enableFiltering: true,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableColumnResizing: true,
              maxWidth: 250,
            }, {
              name: 'DisableSMS',
              visible: true,
              displayName: 'Disable SMS',
              enableHiding: true,
              enableSorting: true,
              enableFiltering: true,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableColumnResizing: true,
              maxWidth: 250,
            }, {
              name: 'AllowAgentAccess',
              visible: true,
              displayName: 'Agent Access',
              enableHiding: true,
              enableSorting: true,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableFiltering: true,
              enableColumnResizing: true,
              maxWidth: 250,
            }, {
              name: 'IsAdmin',
              visible: true,
              displayName: 'Admin Access',
              enableHiding: true,
              enableSorting: true,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableFiltering: true,
              enableColumnResizing: true,
              maxWidth: 250,
            }, ],
            onRegisterApi: function(gridApi) {
              $scope.gridApi = gridApi;
              $scope.gridApi.core.on.sortChanged($scope, function(grid, sortColumns) {
                if (!sortColumns.length) {
                  paginationOptions.sort = null;
                } else {
                  paginationOptions.sort = sortColumns[0].sort.direction;
                }
                updateGridPagination($scope.gridActiveUserOptions.data);
                showReport(selectedClientId);
              });
              gridApi.pagination.on.paginationChanged($scope, function(newPage, pageSize) {
                paginationOptions.pageNumber = newPage;
                paginationOptions.pageSize = pageSize;
                updateGridPagination($scope.gridActiveUserOptions.data);
                showReport(selectedClientId);
              });
            },
          };
        };
        $scope.gridActiveUserOptions = [];

        function getActiveUserReport() {
          progress.start();
          report.getActiveUser().then(function(response) {
              progress.complete();
              let activeUserContext = getActivedUser(response.data);
              $scope.isExportData = !!activeUserContext.length ? true : false;
              $scope.gridTranOptions = userGridOption();
              $scope.gridTranOptions.data = activeUserContext;
              gridData = $scope.gridTranOptions.data;
              $scope.gridTranOptions.totalItems = activeUserContext.length;
              updateGridPagination(activeUserContext);
              transactionGrid();
            }, function(err) {
              if (err.status != 401) {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = `<p>${err.statusText}</p>`;
                    $scope.errTitle = 'Report Error';
                  },],
                });
              }
            })
            .finally(function() {
              progress.complete();
            });
        };

        function getActivedUser(members) {
          return members.filter(function(member) {
            return (member.AccountEnabled);
          }).map(function(member) {
            return {
              Id: member.Id,
              FirstName: member.FirstName,
              LastName: member.LastName,
              Phone: member.Phone,
              Email: member.Email,
              TripLinkEmail: member.TripLinkEmail,
              DisableSMS: ((member.DisableSMS) ? 'Yes' : 'No'),
              AllowAgentAccess: ((member.AllowAgentAccess) ? 'Yes' : 'No'),
              IsAdmin: ((member.IsAdmin) ? 'Yes' : 'No'),
            };
          });
        };

        function getBookingActiveUserReport(fromdate, todate, organizationId) {
          const promiseFlight = report.getAirActivity(fromdate, todate, organizationId);
          const promiseCar = report.getCarActivity(fromdate, todate, organizationId);
          const promiseHotel = report.getHotelActivity(fromdate, todate, organizationId);
          $q.all([promiseFlight, promiseCar, promiseHotel]).then(
              function(response) {
                let membersList = [];
                let flightsContext = response[0].data;
                let carsContext = response[1].data;
                let hotelsContext = response[2].data;
                let flightMembersList = getFlightMembers(flightsContext);
                let carMembersList = getCarMembers(carsContext);
                let hotelMembersList = getHotelMembers(hotelsContext);
                membersList.push.apply(membersList, flightMembersList);
                membersList.push.apply(membersList, carMembersList);
                membersList.push.apply(membersList, hotelMembersList);
                let activeBookingUserContext = getBookingActiveUsers(membersList);
                $scope.isExportData = !!activeBookingUserContext.length ? true : false;
                $scope.gridTranOptions = userGridOption();
                $scope.gridTranOptions.data = activeBookingUserContext;
                gridData = $scope.gridTranOptions.data;
                $scope.gridTranOptions.totalItems = activeBookingUserContext.length;
                updateGridPagination(activeBookingUserContext);
                transactionGrid();
              },
              function(err) {
                if (err.status != 401) {
                  ngDialog.open({
                    template: 'templates/partials/viewErrorMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function ($scope) {
                      $scope.errMsg = `<p>${err.statusText}</p>`;
                      $scope.errTitle = 'Report Error';
                    },],
                  });
                }
              })
            .finally(function() {
              progress.complete();
            });
        };

        function getBookingActiveUsers(membersList) {
          return membersList.reduce(function(newMemberList, member) {
            if (_.findIndex(newMemberList, function(o) {
                return o.Id == member.Id;
              }) === -1) {
              newMemberList.push(member);
            }
            return newMemberList;
          }, []);
        };

        function getFlightMembers(flights) {
          return flights.map(function(flight) {
            let firstName, lastName;
            if (flight.AirReservation.AirTravelers[0].GivenName !== null && flight.AirReservation.AirTravelers[
                0].LastName !== null) {
              firstName = flight.AirReservation.AirTravelers[0].GivenName;
              lastName = flight.AirReservation.AirTravelers[0].LastName;
            } else if (!!flight.Member) {
              firstName = flight.Member.FirstName;
              lastName = flight.Member.LastName;
            } else {
              firstName = '';
              lastName = '';
            }
            return {
              Id: ((!!flight.Member) ? flight.Member.Id : ''),
              FirstName: firstName,
              LastName: lastName,
              Phone: ((!!flight.Member) ? flight.Member.Phone : ''),
              Email: ((!!flight.Member) ? flight.Member.Email : ''),
              TripLinkEmail: ((!!flight.Member) ? flight.Member.TripLinkEmail : ''),
              DisableSMS: ((!!flight.Member) ? ((flight.Member.DisableSMS) ? 'Yes' : 'No') : ''),
              AllowAgentAccess: ((!!flight.Member) ? ((flight.Member.AllowAgentAccess) ? 'Yes' : 'No') : ''),
              IsAdmin: ((!!flight.Member) ? ((flight.Member.IsAdmin) ? 'Yes' : 'No') : ''),
            };
          });
        };

        function getHotelMembers(hotels) {
          return hotels.map(function(hotel) {
            let name, firstName, lastName;
            if (hotel.GuestNames !== null) {
              name = hotel.GuestNames;
              name = name.split(" ");
              firstName = name[0];
              lastName = name[1];
            } else if (!!hotel.Member) {
              firstName = hotel.Member.FirstName;
              lastName = hotel.Member.LastName;
            } else {
              firstName = '';
              lastName = '';
            }
            return {
              Id: ((!!hotel.Member) ? hotel.Member.Id : ''),
              FirstName: firstName,
              LastName: lastName,
              Phone: ((!!hotel.Member) ? hotel.Member.Phone : ''),
              Email: ((!!hotel.Member) ? hotel.Member.Email : ''),
              TripLinkEmail: ((!!hotel.Member) ? hotel.Member.TripLinkEmail : ''),
              DisableSMS: ((!!hotel.Member) ? ((hotel.Member.DisableSMS) ? 'Yes' : 'No') : ''),
              AllowAgentAccess: ((!!hotel.Member) ? ((hotel.Member.AllowAgentAccess) ? 'Yes' : 'No') : ''),
              IsAdmin: ((!!hotel.Member) ? ((hotel.Member.IsAdmin) ? 'Yes' : 'No') : ''),
            };
          });
        };

        function getCarMembers(cars) {
          return cars.map(function(car) {
            let name, firstName, lastName;
            if (car.Travelers !== null) {
              name = car.Travelers;
              name = name.split(" ");
              firstName = name[0];
              lastName = name[1];
            } else if (!!car.Member) {
              firstName = car.Member.FirstName;
              lastName = car.Member.LastName;
            } else {
              firstName = '';
              lastName = '';
            }
            return {
              Id: ((!!car.Member) ? car.Member.Id : ''),
              FirstName: firstName,
              LastName: lastName,
              Phone: ((!!car.Member) ? car.Member.Phone : ''),
              Email: ((!!car.Member) ? car.Member.Email : ''),
              TripLinkEmail: ((!!car.Member) ? car.Member.TripLinkEmail : ''),
              DisableSMS: ((!!car.Member) ? ((car.Member.DisableSMS) ? 'Yes' : 'No') : ''),
              AllowAgentAccess: ((!!car.Member) ? ((car.Member.AllowAgentAccess) ? 'Yes' : 'No') : ''),
              IsAdmin: ((!!car.Member) ? ((car.Member.IsAdmin) ? 'Yes' : 'No') : ''),
            };
          });
        };
        $scope.exportReport = function() {
          let tempFileName = ($scope.reportId === 1) ? 'Air_Activity_Report.csv' : ($scope.reportId === 2) ? 'Hotel_Activity_Report.csv' : ($scope.reportId === 4) ? 'All_Transaction_Report.csv' : ($scope.reportId === 3) ? 'Car_Activity_Report.csv' : 'Report.csv';
          $scope.gridApi.grid.options.exporterCsvFilename = tempFileName;
          $scope.gridApi.exporter.csvExport('all', $scope.columnTypeId);
        };

        function smsLogsGridOption() {
          return {
            paginationPageSizes: [5, 10, 25, 50],
            enableFiltering: true,
            enableGridMenu: true,
            paginationPageSize: 25,
            useExternalPagination: false,
            useExternalSorting: false,
            enableColumnResizing: true,
            exporterMenuPdf: false,
            exporterMenuCsv: false,
            exporterCsvFilename: 'Report.csv',
            columnDefs: [{
              name: 'Traveler',
              visible: true,
              displayName: 'Traveler',
              enableHiding: true,
              enableSorting: true,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableFiltering: true,
              enableColumnResizing: true,
              maxWidth: 250,
              sort: {
                direction: uiGridConstants.ASC,
                priority: 0,
              },
            }, {
              name: 'Company',
              visible: true,
              displayName: 'Company',
              enableHiding: true,
              enableSorting: true,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableFiltering: true,
              enableColumnResizing: true,
              maxWidth: 250,
            }, {
              name: 'Phone',
              visible: true,
              displayName: 'Phone',
              enableHiding: true,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableSorting: true,
              enableFiltering: true,
              enableColumnResizing: true,
              maxWidth: 250,
            }, {
              name: 'Email',
              visible: true,
              displayName: 'Email',
              enableHiding: true,
              enableSorting: true,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableFiltering: true,
              enableColumnResizing: true,
              maxWidth: 250,
            }, {
              name: 'Time',
              visible: true,
              enableHiding: true,
              displayName: 'Time',
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableSorting: true,
              enableFiltering: true,
              enableColumnResizing: true,
              maxWidth: 250,
            }, {
              name: 'Message',
              visible: true,
              displayName: 'Message',
              enableHiding: true,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableSorting: true,
              enableFiltering: true,
              enableColumnResizing: true,
              maxWidth: 250,
            }, {
              name: 'Booking',
              visible: true,
              displayName: 'Booking',
              enableHiding: false,
              sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
              enableSorting: false,
              enableFiltering: false,
              enableColumnResizing: true,
              cellClass: 'grid-align',
            }, ],
            onRegisterApi: function(gridApi) {
              $scope.gridApi = gridApi;
              $scope.gridApi.core.on.sortChanged($scope, function(grid, sortColumns) {
                if (!sortColumns.length) {
                  paginationOptions.sort = null;
                } else {
                  paginationOptions.sort = sortColumns[0].sort.direction;
                }
                updateGridPagination($scope.gridSMSLogsOptions.data);
                showReport(selectedClientId);
              });
              gridApi.pagination.on.paginationChanged($scope, function(newPage, pageSize) {
                paginationOptions.pageNumber = newPage;
                paginationOptions.pageSize = pageSize;
                updateGridPagination($scope.gridSMSLogsOptions.data);
                showReport(selectedClientId);
              });
            },
          };
        };
        $scope.gridSMSLogsOptions = [];

        function getSMSLogsReport(fromdate, todate, organizationId) {
          progress.start();
          report.getSMSActivity(fromdate, todate, organizationId).then(function(response) {
              let smsLogsContext = getSMSLogs(response.data);
              $scope.isExportData = !!smsLogsContext.length ? true : false;
              $scope.gridSMSLogsOptions = smsLogsGridOption();
              gridData = $scope.gridSMSLogsOptions;
              $scope.gridTranOptions.data = smsLogsContext;
              $scope.gridTranOptions.totalItems = smsLogsContext.length;
              updateGridPagination(smsLogsContext);
              smsLogGrid();
            }, function(err) {
              if (err.status != 401) {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = `<p>${err.statusText}</p>`;
                    $scope.errTitle = 'Report Error';
                  },],
                });
              }
            })
            .finally(function() {
              progress.complete();
            });
        };

        function getSMSLogs(members) {
          return members
            .map(function(member) {
              return {
                Traveler: member.Member.DisplayName,
                Company: member.Member.Organization.Name,
                Phone: member.Phone,
                Email: member.Member.Email,
                Time: member.LastUpdated,
                Message: member.Message,
                Booking: (!!member.FlightId ? 'Flight' : (!!member.CarId ? 'Car' : (!!member.HotelId ? 'Hotel' :
                  ' '))),
              };
            });
        };
        //on page load shwoing data in grid
        $scope.getProfileFields();
        $scope.getProfiles();
        $scope.searchReport();
        // Watch clientSelectService for changes to getFilteredOrganization() output -- expensive, calls getFilteredOrganization many times during $digest cycle
        $scope.$watch(function() {
          return clientSelectService.getSelectedClient();
        }, function(newValue, oldValue) {
          if (newValue !== oldValue) {
            // Clear ui-grid
            $scope.gridDetails.data = [];
            $scope.gridDetails.totalItems = 0;
            $scope.getProfileFields();
            $scope.getProfiles();
            $scope.searchReport();
          }
        }, true);
      },
    ]);
})(angular.module('obex'));


// WEBPACK FOOTER //
// ./client/js/controllers/reportController.js